import cookie from 'js-cookie'
import ajaxUtil from 'cy_static/ajaxUtil'
import { server } from '../../assets/config/env'
import spaceImg from '../../assets/img/space.png'

export default {
  name: 'GoodsCard',

  props: {

    // 商品名称
    goodsName: {
      type: String,
      default: '商品名称'
    },

    // 商品图片
    goodsPic: {
      type: String
    },

    // 商品类型
    goodsType: {
      type: String
    },

    // 商品支付类型
    goodsPayType: {
      type: String
    },

    // 商品价格
    goodsPrice: {
      type: Number,
      default: 1
    },

    // 商品积分
    goodsPoints: {
      type: Number,
      default: 100
    },

    // 商品库存
    goodsStock: {
      type: Number,
      default: 100
    },

    // 商品跳转链接
    goodsLink: {
      type: String,
      default: 'https://baidu.com'
    },

    // 积分化显示
    goodsDisplayPoints: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      imgCDNHost: server.imgUrl,
      spaceImg
    }
  },

  methods: {
    onImgLoad(e) {
      const imgEl = e.currentTarget

      if (imgEl.getAttribute('data-type') !== 'error') {
        const imgRatio = imgEl.offsetWidth / this.data.picWidth

        imgEl.style.height = this.data.picHeight * imgRatio + 'px'
        imgEl.style.minHeight = '0px'
      }
    },

    onImgErr(e) {
      const imgEl = e.currentTarget

      imgEl.src = spaceImg
      imgEl.style.backgroundColor = '#eee',
      imgEl.setAttribute('data-type', 'error')
    },

    onCardClick() {

    }
  }
}
